import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import './plugins/base';
import VueSweetalert2 from 'vue-sweetalert2';
import Vue2Filters from 'vue2-filters';
import Moment from 'moment';
import Chartkick from 'vue-chartkick';
import Chart from 'chart.js';
import VueI18n from 'vue-i18n';
import VueGtag from 'vue-gtag';
import Meta from 'vue-meta';

import { ApolloClient, HttpLink, ApolloLink, InMemoryCache } from 'apollo-boost';
import VueApollo from 'vue-apollo';

// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process?.env?.VUE_APP_FIREBASE_API_KEY,
  authDomain: process?.env?.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process?.env?.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process?.env?.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process?.env?.VUE_APP_FIREBASE_MESSAGE_SENDER_ID,
  appId: process?.env?.VUE_APP_FIREBASE_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

Vue.config.productionTip = false;

const config = Object.freeze({
  apiUrl: process.env.VUE_APP_API_URL,
});

window._ = require('lodash');

const plugin = {
  install(Vue, options) {
    Vue.prototype.$filters = Vue.options.filters;
    Vue.prototype.$eventHub = new Vue();
    Vue.prototype.$config = config;
    Vue.prototype.$moment = Moment;
  },
};

Vue.use(VueApollo);
Vue.use(VueSweetalert2);
Vue.use(Vue2Filters);
Vue.use(plugin);
Vue.use(Chartkick.use(Chart));
Vue.use(VueI18n);
Vue.use(Meta, { refreshOnceOnNavigation: true });

// Google Analytics (GA4) via vue-gtag
const isProduction = process?.env?.NODE_ENV === 'production';
const gaMeasurementId = process?.env?.VUE_APP_GA_MEASUREMENT_ID;

if (!gaMeasurementId) {
  console.log('VUE_APP_GA_MEASUREMENT_ID NOT SET');
}

if (gaMeasurementId) {
  Vue.use(
    VueGtag,
    {
      config: { id: gaMeasurementId },
      appName: 'Vibracoes Service Finder',
      enabled: isProduction,
    },
    router
  );
}

const link = new HttpLink({ uri: config.apiUrl });

const authLink = new ApolloLink((operation, forward) => {
  // Retrieve the authorization token from local storage.
  const token = localStorage.getItem('token');
  // Use the setContext method to set the HTTP headers.
  operation.setContext({
    headers: {
      authorization: token ? `Bearer ${token}` : '',
    },
  });
  // Call the next link in the middleware chain.
  return forward(operation);
});

const cache = new InMemoryCache();
const apolloClient = new ApolloClient({
  cache,
  link: authLink.concat(link),
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

Vue.filter('getFormattedDate', (value) => {
  const ret = new Moment(value).format('YYYY-MM-DD HH:mm');
  return ret;
});

Vue.filter('getFormattedYYYYMMDD', (value) => {
  const ret = new Moment(value).format('YYYY-MM-DD');
  return ret;
});

Vue.filter('getFormattedYYYYMM', (value) => {
  const ret = new Moment(value).format('YYYY-MM');
  return ret;
});
//www.google.com/maps/dir//-26.205,28.047/@-26.205,28.047,17z
Vue.filter('getMapsLink', (value) => {
  return `<a target="_blank" href="https://www.google.com/maps/place/${value[1]},${value[0]}">View Location on Map</a>,
          <a target="_blank" href="https://www.google.com/maps/dir/?api=1&origin=${value[3]},${value[2]}&destination=${value[1]},${value[0]}">View Directions</a>`;
});

// import styles
import 'sweetalert2/dist/sweetalert2.min.css';
//import '@/assets/css/styles.css'

console.log(`SERVER: ${process?.env?.NODE_ENV ? process?.env?.NODE_ENV : 'NODE_ENV NOT SET'}`);
console.log(
  `API URL: ${
    process && process.env && process?.env?.VUE_APP_API_URL ? process.env.VUE_APP_API_URL : 'VUE_APP_API_URL NOT SET'
  }`
);
if (!process?.env?.VUE_APP_FIREBASE_API_KEY) {
  console.log('VUE_APP_FIREBASE_API_KEY NOT SET');
} else if (!process?.env?.VUE_APP_FIREBASE_AUTH_DOMAIN) {
  console.log('VUE_APP_FIREBASE_AUTH_DOMAIN NOT SET');
} else if (!process?.env?.VUE_APP_FIREBASE_PROJECT_ID) {
  console.log('VUE_APP_FIREBASE_PROJECT_ID NOT SET');
} else if (!process?.env?.VUE_APP_FIREBASE_STORAGE_BUCKET) {
  console.log('VUE_APP_FIREBASE_STORAGE_BUCKET NOT SET');
} else if (!process?.env?.VUE_APP_FIREBASE_MESSAGE_SENDER_ID) {
  console.log('VUE_APP_FIREBASE_MESSAGE_SENDER_ID NOT SET');
} else if (!process?.env?.VUE_APP_FIREBASE_APP_ID) {
  console.log('VUE_APP_FIREBASE_APP_ID NOT SET');
}

new Vue({
  router,
  vuetify,
  apolloProvider,
  i18n: new VueI18n({
    locale: 'pt',
    messages: {
      en: {
        search: {
          address: 'Address',
          close: 'Close',
          contactInformation: 'Contact Information',
          comments: 'Comments',
          createReview: 'Create Review',
          createReviewForLocation: 'Create your own review for this location',
          emailAddress: 'Email Address',
          enableLocationServices: 'Enable location services and refresh the page',
          facilitiesNearYou: 'Facilities near you',
          friendliness: 'Friendliness',
          inputLocation: 'Input your location above to find the services closest to you',
          locationInformation: 'Location Information',
          locationServices: 'This Application Requires You to Have Location Services Enabled',
          noReviews: 'There are no reviews for this location',
          pleaseSelectCategory: 'Please select a category to view facilities near you.',
          privacy: 'Privacy',
          rating: 'Rating',
          reviews: 'Reviews',
          save: 'Save',
          searchInput: 'Type in your location here',
          selectService: 'Select the service you are looking for',
          serviceType: 'Service Type',
          signedInAs: 'Signed in as',
          signIn: 'Sign in',
          signOut: 'Sign out',
          talkToSomeBody: 'Talk to Somebody',
          telephoneNumber: 'Telephone Number',
          waitingTime: 'Waiting Time',
        },
      },
      pt: {
        search: {
          address: 'Endereço',
          close: 'Fechar',
          contactInformation: 'Informações de Contato',
          comments: 'Comentários',
          createReview: 'Criar Avaliação',
          createReviewForLocation: 'Crie sua própria avaliação para este local',
          emailAddress: 'Endereço de Email',
          enableLocationServices: 'Habilite os serviços de localização e atualize a página',
          facilitiesNearYou: 'Instalações perto de você',
          friendliness: 'Amabilidade',
          inputLocation: 'Insira sua localização acima para encontrar os serviços mais próximos de você',
          locationInformation: 'Informações de Localização',
          locationServices: 'Este Aplicativo Requer Que Você Habilite os Serviços de Localização',
          noReviews: 'Não há avaliações para este local',
          pleaseSelectCategory: 'Selecione uma categoria para visualizar as instalações perto de você.',
          privacy: 'Privacidade',
          rating: 'Classificação',
          reviews: 'Avaliações',
          save: 'Salvar',
          searchInput: 'Digite sua localização aqui',
          selectService: 'Selecione o serviço que você está procurando',
          serviceType: 'Tipo de Serviço',
          signedInAs: 'Conectado como',
          signIn: 'Entrar',
          signOut: 'Sair',
          talkToSomeBody: 'Falar com Alguém',
          telephoneNumber: 'Número de Telefone',
          waitingTime: 'Tempo de Espera',
        },
      },
    },
  }),
  render: (h) => h(App),
}).$mount('#app');

// Signal to PrerenderSPAPlugin that the app is ready (used during production build)
try {
  if (typeof document !== 'undefined') {
    document.dispatchEvent(new Event('app-rendered'));
  }
} catch (e) {
  // no-op
}

// Signal to prerenderer that the app has finished rendering
document.dispatchEvent(new Event('app-rendered'));
